import {useUnit} from 'effector-react';
import {
    $applications,
    $applicationsTable,
    ApplicationsGate, getApplicationsFx, selectApplicationEv, setApplicationsTableEv
} from '../../models/applicationsModel/index.js';
import {useTranslation} from 'react-i18next';
import {useLocation, useSearchParams} from 'react-router-dom';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Card} from 'primereact/card';
import ApplicationInfoBar from '../ApplicationInfoBar/ApplicationInfoBar.jsx';

export default function ApplicationsTable({type}) {
    const {t} = useTranslation()
    const [search] = useSearchParams()
    const {pathname} = useLocation()

    const {data, count} = useUnit($applications)
    const loading = useUnit(getApplicationsFx.pending)
    const {limit, first} = useUnit($applicationsTable)

    const setTable = useUnit(setApplicationsTableEv)
    const selectApp = useUnit(selectApplicationEv)

    const columns = [
        {field: 'id', header: t('ID')},
        {field: 'category', header: t('Категория заявки')},
        {field: 'status', header: t('Статус'), body: (row) => t(`app_status.${row.status}`)},
        {field: 'applicant_bin', header: t('БИН')},
        {field: 'applicant_fullname', header: t('Заявитель')},
        {field: 'message', header: t('Сообщение')},
        {field: 'provider_message', header: t('Ответ')},
        {field: 'application_date', header: t('Дата заявки')},
    ]

    return <Card className={'shadow-1'}>
        <ApplicationsGate type={type ?? ''} search={search}/>
        <ApplicationInfoBar />
        <DataTable value={data}
                   stripedRows
                   lazy
                   first={first}
                   rows={limit}
                   loading={loading}
                   paginator
                   rowsPerPageOptions={[10, 20, 50]}
                   selectionMode={'single'}
                   totalRecords={count}
                   dataKey={'id'}
                   onSelectionChange={(e) => pathname.includes('my-applications') ? undefined : selectApp(e.value.id)}
                   onPage={e => {
                       setTable({
                           page: e.page,
                           offset: e.first,
                           totalPages: (count / e.rows),
                           limit: e.rows,
                           first: e.first
                       })
                   }}
        >
            {columns.map((col) =>
                <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    bodyStyle={col.field === 'status' ? {textWrap: 'nowrap'} : {}}
                    body={col.body ?? undefined}
                />
            )}
        </DataTable>
    </Card>
}